import { createContext, useContext } from "react";

export const LabContext = createContext();

export function useLab() {
  return useContext(LabContext);
}
